import { RouteObject } from 'react-router-dom';
import { RoutesEnum } from '~/constants/enums';
import UserSubscription from '~myAccount/pages/UserSubscription';

const routes: RouteObject[] = [
  {
    path: RoutesEnum.USER_SUBSCRIPTION,
    children: [{ index: true, element: <UserSubscription /> }],
  },
];

export default routes;
